module.exports = __webpack_public_path__ + "static/img/DANIEL-ANNABLE.749d25c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DANIEL-ANNABLE.jpg
// module id = UQfT
// module chunks = 0